module.exports = __webpack_public_path__ + "img/a076ecdca1714794bf013efa3defada9.png";